import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateEventShareTemplate } from '_redux/modules/event'
import useEventCardActions from './useEventCardActions'

export default function useShareTemplate() {
  const dispatch = useDispatch()
  const { exportTemplate, useAsTemplate } = useEventCardActions()

  const [isShareTemplateMenuOpen, setIsShareTemplateMenuOpen] = useState(false)
  const [isUpdatingShare, setIsUpdatingShare] = useState(false)

  const onClickIconDownload = (e) => {
    e?.preventDefault?.()
    e?.stopPropagation?.()
    setIsShareTemplateMenuOpen((prev) => !prev)
  }

  const closeMenu = () => setIsShareTemplateMenuOpen(false)

  const handleDownloadExcel = (eventId) => exportTemplate(eventId, 'excel')
  const handleDownloadPDF = (eventId) => exportTemplate(eventId, 'pdf')
  const handleUseAsTemplate = (eventId) => useAsTemplate(eventId)

  const toggleShareTemplate = async (event) => {
    if (isUpdatingShare || !event?.id) return
    try {
      setIsUpdatingShare(true)
      const nextState = !event.isSharingTemplate
      await dispatch(updateEventShareTemplate({ id: event.id, isSharingTemplate: nextState }))
    } catch (error) {
      // ignore
    } finally {
      setIsUpdatingShare(false)
    }
  }

  return {
    isShareTemplateMenuOpen,
    onClickIconDownload,
    closeMenu,
    handleDownloadExcel,
    handleDownloadPDF,
    handleUseAsTemplate,
    toggleShareTemplate,
    isUpdatingShare,
  }
}
